<template>
  <div class="b_c_232526e6 sticky">
    <div class="w_1200 m_lr_auto flex j_c_s_b a_i_c c_fff h_64 f_s_14">
      <div class="">
        <div class="cursor_p btn" v-if="product.imageText && product.imageText.length" @click="onClick(0)">{{ product.name }}</div>
        <div v-else>{{ product.name }}</div>
      </div>
      <div class="flex">
        <!-- <div class="m_r_20 cursor_p btn" @click="onClick(1)">技术参数</div> -->
        <!-- <div class="m_r_20 cursor_p btn" @click="onClick(1)">机型比较</div> -->
        <!-- <div class="m_r_20 cursor_p btn" @click="onClick(2)">视频</div> -->
        <!-- <div class="m_r_20 cursor_p btn" @click="onClick(1)">常见问题</div> -->
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 二级导航组件
 *
 */
export default {
  name: "SubNav",
  props: {
    product: {
      type: Object,
      default: () => {
        return {imageText:[], overview: {}}
      }
    }
  },
  methods: {
    onClick (type) {
      this.$emit("click", type);
    }
  }
};
</script>

<style></style>